import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../SafeIcon';
import { FiX, FiLink, FiCheck } from 'react-icons/fi';

const TIKTOK_ICON = "https://media-manager-c.questera.ai/greta-media/905f91485ab63acb0ca3d0eb7a8d12edb0e5fd8263e0c7ad4c0bd7710abc0b3f680db9e50b9a6deeaa0ab59826a97d73/images/aW1hZ2UvaGVpYw==/2a6a5e6c6f1f3e4d8b9c0a1e2f3d4c5b.heic";
const FB_ICON = "https://media-manager-c.questera.ai/greta-media/905f91485ab63acb0ca3d0eb7a8d12edb0e5fd8263e0c7ad4c0bd7710abc0b3f680db9e50b9a6deeaa0ab59826a97d73/images/aW1hZ2UvaGVpYw==/a01d62b241ae7f4a2692d9572464d8d1.heic";
const IG_ICON = "https://media-manager-c.questera.ai/greta-media/905f91485ab63acb0ca3d0eb7a8d12edb0e5fd8263e0c7ad4c0bd7710abc0b3f680db9e50b9a6deeaa0ab59826a97d73/images/aW1hZ2UvaGVpYw==/8dd5684d7eadd9b6ca242a625cbcd549.heic";

const SocialLinksPopup = ({ onClose, onUpdate, currentLinks = {} }) => {
  const [links, setLinks] = useState({
    tiktok: currentLinks.tiktok || '',
    instagram: currentLinks.instagram || '',
    facebook: currentLinks.facebook || ''
  });

  const handleSave = () => {
    onUpdate(links);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="bg-white rounded-[2rem] shadow-2xl w-full max-w-md overflow-hidden"
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/80">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-gradient-to-br from-pink-500 via-purple-500 to-blue-500 rounded-2xl">
              <SafeIcon icon={FiLink} className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-black text-gray-900 text-xl uppercase tracking-tight">Social Links</h3>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Add your social media URLs</p>
            </div>
          </div>
          <button onClick={onClose} className="bg-white p-2.5 rounded-xl shadow-sm hover:shadow-md transition-all text-gray-400 hover:text-gray-600 border border-gray-100">
            <SafeIcon icon={FiX} className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* TikTok */}
          <div className="space-y-3">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center">
              <img src={TIKTOK_ICON} className="w-5 h-5 rounded object-cover mr-2" alt="TikTok" />
              TikTok
            </label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300">
                <SafeIcon icon={FiLink} className="w-4 h-4" />
              </div>
              <input
                type="url"
                value={links.tiktok}
                onChange={(e) => setLinks({ ...links, tiktok: e.target.value })}
                placeholder="https://tiktok.com/@yourusername"
                className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all text-sm"
              />
            </div>
          </div>

          {/* Instagram */}
          <div className="space-y-3">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center">
              <img src={IG_ICON} className="w-5 h-5 rounded object-cover mr-2" alt="Instagram" />
              Instagram
            </label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300">
                <SafeIcon icon={FiLink} className="w-4 h-4" />
              </div>
              <input
                type="url"
                value={links.instagram}
                onChange={(e) => setLinks({ ...links, instagram: e.target.value })}
                placeholder="https://instagram.com/yourusername"
                className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all text-sm"
              />
            </div>
          </div>

          {/* Facebook */}
          <div className="space-y-3">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center">
              <img src={FB_ICON} className="w-5 h-5 rounded object-cover mr-2" alt="Facebook" />
              Facebook
            </label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300">
                <SafeIcon icon={FiLink} className="w-4 h-4" />
              </div>
              <input
                type="url"
                value={links.facebook}
                onChange={(e) => setLinks({ ...links, facebook: e.target.value })}
                placeholder="https://facebook.com/yourpage"
                className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm"
              />
            </div>
          </div>

          {/* Preview */}
          <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3">Preview</p>
            <div className="flex items-center space-x-3">
              {links.tiktok && (
                <a href={links.tiktok} target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform block">
                  <img src={TIKTOK_ICON} className="w-8 h-8 object-cover rounded-lg shadow-sm" alt="TikTok" />
                </a>
              )}
              {links.instagram && (
                <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform block">
                  <img src={IG_ICON} className="w-8 h-8 object-cover rounded-lg shadow-sm" alt="Instagram" />
                </a>
              )}
              {links.facebook && (
                <a href={links.facebook} target="_blank" rel="noopener noreferrer" className="hover:scale-110 transition-transform block">
                  <img src={FB_ICON} className="w-8 h-8 object-cover rounded-lg shadow-sm" alt="Facebook" />
                </a>
              )}
              {!links.tiktok && !links.instagram && !links.facebook && (
                <span className="text-sm text-gray-400 italic">No links added yet</span>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 bg-gray-50 border-t border-gray-100 flex space-x-4">
          <button onClick={onClose} className="flex-1 py-4 font-black text-gray-400 hover:text-gray-600 uppercase tracking-widest text-xs transition-colors">
            Cancel
          </button>
          <button onClick={handleSave} className="flex-[2] py-4 bg-gray-900 text-white font-black uppercase tracking-widest text-xs rounded-2xl shadow-xl shadow-gray-200 hover:bg-teal-600 hover:shadow-teal-100 transition-all">
            Save Links
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default SocialLinksPopup;